import request from '@/axios'

export function  getEventApi (payload, customer_id) {
  return request({
    url: `/schedule/get/${customer_id}`,
    method: 'POST',
    data: payload
  })
}
export function  CreateGeneralEventApi (payload) {
  return request({
    url: '/ClientUser/schedule/create',
    method: 'POST',
    data: payload
  })
}
export function  UpdateGeneralEventApi (payload) {
  return request({
    url: '/ClientUser/schedule/edit/',
    method: 'POST',
    data: payload
  })
}
export function  DeleteScheduleApi (event_id) {
  return request({
    url: `/ClientUser/schedule/delete/${event_id}`,
    method: 'POST'
  })
}


//teacher List Api
export function TeacherListApi (customer_id) {
  return request({
    url: `/schedule/teachers/${customer_id}`,
    method: 'POST'
  })
}

export function StudentListAPi (customer_id) {
  return request({
    url: `/schedule/students/${customer_id}`,
    method: 'POST'
  })
}
// http://localhost:8000/api/ClientUser/schedule/get
// {
// "course_ids": [44]
// }

// get course schedules
export function ClientScheduleApi (payload, customer_id) {
  return request({
    url: `V1/ClientUser/schedule/get/${customer_id}`,
    method: 'POST',
    data:payload
  })
}

export function GetCourseLists (payload = null) {
  return request({
    url: '/ClientUser/schedule/course-list',
    method: 'POST',
    data:payload
  })
}

export function GetClientCourseLists (customer_id, payload = null) {
  return request({
    url: `/V1/ClientUser/schedule/course/list/${customer_id}`,
    method: 'POST',
    data:payload
  })
}

export function updateRescheduleApi (course_id, customer_id, payload) {

  return request({
    url:`ClientUser/course/reschedule/${course_id}/${customer_id}`,
    method:'POST',
    data:payload
  })

}

export function cancelRescheduleUpdateApi (customer_id, payload) {

  return request({
    url:`course/reschedule/canceled/${customer_id} `,
    method:'POST',
    data:payload
  })

}


export function getShedulerLogApi (customer_id, payload) {
  return request({
    url:`ClientUser/course/schedule/log/${customer_id}`,
    method:'POST',
    data:payload
  })
}

export function cancelSchedulerApi (customer_id, payload) {
  return request({
    url:`course/schedule/cancel/${customer_id}`,
    method:'POST',
    data:payload
  })
}

export function getCancelSchedulerApi (payload, customer_id) {
  return request({
    url:`course/schedule/get/cancel/${customer_id}`,
    method:'POST',
    data:payload
  })
}


export function getTeacherAvailabilityApi (customer_id, payload) {

  return request({
    url:`ClientUser/course/reschedule/availability/${customer_id}`,
    method:'POST',
    data:payload

  })
}

export function getClassSchedule (payload) {
  return request({
    url: 'ClientUser/classes/get-class-schedule',
    method: 'POST',
    data: payload
  })
}

export function checkCourseOrClass (payload) {
  return request({
    url: 'ClientUser/schedules/course-or-class',
    method: 'POST',
    data: payload
  })
}

export function calenderNoteList (payload, customer_id) {
  return request({
    url: `V1/ClientUser/schedule/note/list/${customer_id}`,
    method: 'POST',
    data: payload
  })
}

export function fetchDateRange (customer_id, course_id) {
  return request({
    url: `V1/ClientUser/course/range/${customer_id}/${course_id}`,
    method: 'GET'
  })
}

export function  courseMoreDetails (payload, customer_id) {
  return request({
    url: `V1/ClientUser/schedule/course/more_info/${customer_id}`,
    method: 'POST',
    data: payload
  })
}

export function  classDetailsFetch (class_id, customer_id) {
  return request({
    url: `ClientUser/classes/show/${class_id}/${customer_id}`,
    method: 'GET'
  })
}

export function  classSubjectFetch (customer_id, payload) {
  return request({
    url: `ClientUser/classes/getPeriodSubject/${customer_id}`,
    method: 'POST',
    data: payload
  })
}

// http://localhost:8000/api/ClientUser/schedule/course-list


// export function  addEvent (payload, customer_id) {
//   return request({
//     url: `/blog/create/${customer_id}`,
//     method: 'POST',
//     data: payload
//   })
// }

// export function  deleteEvent (payload, customer_id) {
//   return request({
//     url: `/blog/create/${customer_id}`,
//     method: 'POST',
//     data: payload
//   })
// }
